import { render, staticRenderFns } from "./RoleUsersList.vue?vue&type=template&id=80a4a0c8&scoped=true&"
import script from "./RoleUsersList.vue?vue&type=script&lang=ts&"
export * from "./RoleUsersList.vue?vue&type=script&lang=ts&"
import style0 from "./RoleUsersList.vue?vue&type=style&index=0&id=80a4a0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a4a0c8",
  null
  
)

export default component.exports